import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api'
// import { SelectOrderItem } from '@features/order-item'

// const store = useStore()


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderItem',
  props: {
  data: {
    type: Object,
    required: true
  },
  currencyIcon: {
    type: String,
    default: '₽'
  },
  diffCheck: {
    type: Boolean,
    default: false
  },
  guest: {
    type: String || Number,
    required: true
  }
},
  setup(__props) {

const props = __props

// import { computed, useStore } from '@nuxtjs/composition-api'


const itemStatus = computed(() => {
  if (props.data.status === 'PAID') { return 'payed' }
  if (props.data.loading) { return 'loading' }
  if (props.data.selected_guest_id === props.guest) { return 'not pay' }
  if (props.data.selected_guest_id && props.data.status === 'NOT_PAID') {
    return 'paying'
  }
  return 'not pay'
})

// Статусы для автотестов
const dataAuto = computed(() => {
  if (itemStatus.value === 'payed') { return 'paidDishes' }
  if (itemStatus.value === 'loading') { return 'processDishes' }
  if (itemStatus.value === 'not pay' && props.data.diffCheck) { return 'nonPaidDishes' }
  if (itemStatus.value === 'paying') { return 'disabledDishes' }
  return ''
})

const itemStatusName = computed(() => {
  if (itemStatus.value === 'payed') { return 'Оплачено' }
  if (itemStatus.value === 'loading') { return 'Подождите' }
  if (itemStatus.value === 'not pay') { return 'Не оплачено' }
  if (itemStatus.value === 'paying') { return 'Оплачивается другим гостем' }
  return ''
})

// const hasDifferentPrice = computed(() => props.data.finalPrice !== props.data.price)

// const paymentCheck = computed(() => {
//   if (props.data.selected_guest_id) {
//     return props.data.selected_guest_id !== props.guest
//   }
//   return false
// })

// const checkPosition = async () => {
//   if (!props.data.diffCheck || itemStatus.value === 'payed') { return }
//   if (!paymentCheck.value && itemStatus.value !== 'loading') {
//     // orderModel.loadingOrderElement(props.data.id)
//     // const localGuest = await sessionStorage.getItem('guest')
//     // this.$emit('checkPosition', {
//     //   id: this.data.id.toString(),
//     //   status: this.data.selected_guest_id === metaModel.guest,
//     //   guest: localGuest ? parseInt(localGuest) : null
//     // })
//   }
// }


return { __sfc: true,props, itemStatus, dataAuto, itemStatusName }
}

})